import { render, staticRenderFns } from "./form.vue?vue&type=template&id=19f282c0&scoped=true&"
import script from "./form.vue?vue&type=script&lang=ts&"
export * from "./form.vue?vue&type=script&lang=ts&"
import style0 from "./form.vue?vue&type=style&index=0&id=19f282c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f282c0",
  null
  
)

export default component.exports